<template>
    <div class="profile">
        <!-- Server-specific settings -->
        <router-link class="dashboard-banner box p-3" to="/shop">
            <div class="dashboard-banner-content">
                <h1 class="title is-6 mb-1">Customize your profile!</h1>
                <p class="paragraph is-6">Unlock more skins in the Gamebot shop.</p>
            </div>
        </router-link>
        <main class="dashboard-content columns box">
            <aside class="sidebar column">
                <b-menu-list
                    :model="page">
                    <div class="p-1">
                        <b-menu>
                        <b-menu-list
                        type="is-primary"
                        label="PROFILE">
                            <b-menu-item :active="page === 'Overview'" @click="page = 'Overview'" icon="user" label="Overview" aria-selected="true"></b-menu-item>
                            <b-menu-item :active="page === 'Statistics'" @click="page = 'Statistics'" icon="chart-line" label="Statistics"></b-menu-item>
                            <b-menu-item :active="page === 'Achievements'" @click="page = 'Achievements'" icon="trophy" label="Achievements"></b-menu-item>
                        </b-menu-list>
                        <!-- Server list -->
                        <!--b-menu-list label="SERVERS">
                            <b-menu-item v-for="guild in guilds" :key="guild.id">
                                <template #label>
                                    <span class="icon guild-icon">
                                        <img :src="`https://cdn.discordapp.com/icons/${guild.id}/${guild.icon}.png`" />
                                    </span>
                                    <span class="guild-name">{{ guild.name }}</span>
                                </template>
                            </b-menu-item>
                            <b-message v-if="guilds.length === 0" type="is-warning">No servers found. <a class="inline-link" href="/invite?ref=profile">Invite Gamebot</a> to your server to get started!</b-message>

                            <b-button v-if="!$store.getters.getToken" tag="router-link" icon-left="discord" icon-pack="fab" type="is-discord" inverted :to="{ path: '/login' }">
                                Log in with Discord
                            </b-button>
                        </b-menu-list-->
                        </b-menu>
                    </div>
                </b-menu-list>
            </aside>
            <div v-show="page === 'Overview'" class="column user-dashboard" :style="{ ...profileStyles }">
                <div class="user-profile dashboard-item glass" :style="overlayStyles">
                    <div class="user-info">
                        <div class="circle"></div> <!-- Replace with image -->
                        <div class="user-info-text">
                            <h1 class="user-username user-info-row">{{ $store.state.user.username }}</h1>
                            <div class="user-info-tags">
                                <b-tag rounded>Legend</b-tag>
                                <b-tag rounded>4K Club</b-tag>
                            </div>
                        </div>
                    </div>
                    <div class="column user-statistic">
                        <div class="game-circles user-info-row">
                            <div v-for="game of user.stats.mostPlayed" :key="game.id" class="circle">{{ game.id }}</div>
                        </div>
                        <p class="statistic-description" :style="{}">Most Played</p>
                    </div>
                    <div class="column user-statistic">
                        <div class="user-info-row">
                            <p class="statistic-title">{{ user.stats.totalWins }}</p>
                            <p class="statistic-subtitle" style="margin-bottom: 0;">WINS</p>
                        </div>
                        <p class="statistic-description">Summer 2023</p>
                    </div>
                </div>

                <div class="user-status dashboard-item">
                    <div class="user-achievements dashboard-item glass" :style="overlayStyles">
                        <div class="achievement-list">
                            <div class="achievement">
                                <p class="achievement-title">Unscrambler</p>
                                <div class="achievement-info">
                                    <p class="achievement-description">Play 3 games of Anagrams</p>
                                    <p class="achievement-progress-label">1/3 games</p>
                                </div>
                                <div class="achievement-progress">
                                    <div class="achievement-progress-bar" :style="{ backgroundColor: this.currentTheme.colors.secondary }"></div>
                                </div>
                            </div>

                            <div class="achievement">
                                <p class="achievement-title">Unscrambler</p>
                                <div class="achievement-info">
                                    <p class="achievement-description">Play 3 games of Anagrams</p>
                                    <p class="achievement-progress-label">1/3 games</p>
                                </div>
                                <div class="achievement-progress">
                                    <div class="achievement-progress-bar" :style="{ backgroundColor: this.currentTheme.colors.secondary }"></div>
                                </div>
                            </div>
                        </div>
                        <div class="achievement-timer">
                            <p class="achievement-timer-label">Quests reset in</p>
                            <p class="achievement-timer-countdown">12h 30m</p>
                        </div>
                    </div>

                    <div class="user-balance dashboard-item glass" :style="overlayStyles">
                        <div class="user-balance-content">
                            <p class="user-balance-currency">
                                <img class="currency-icon" src="@/assets/images/currency/256w/credits.png" alt="Gamebot Credits" />
                                <b>Credits</b>
                            </p>
                            <p class="user-balance-amount">{{ $store.state.dbInfo.credits }}</p>
                        </div>

                        <div class="user-balance-content">
                            <p class="user-balance-currency">
                                <img class="currency-icon" src="@/assets/images/currency/256w/gold.png" alt="Gamebot Gold" />
                                <b>Gold</b>
                            </p>
                            <p class="user-balance-amount">{{ $store.state.dbInfo.gold }}</p>
                        </div>
                    </div>
                </div>

                <div class="xp-progress-bar dashboard-item glass" :style="overlayStyles">
                    <div class="current-progress">
                    </div>
                    <p class="xp-progress-label">
                        <b>Level {{ this.user.stats.level || 0 }}</b>
                        &nbsp;{{ displayExperience }} Experience
                    </p>
                </div>

                <div class="user-experience dashboard-item">
                    <div class="rewards-container">
                        <div v-for="(reward, i) in rewards" :key="i" class="reward-container" :class="{ 'locked': reward.premium && !user.premium }">
                            <div class="reward glass" :style="overlayStyles" :class="{ premium: reward.premium }">
                                {{ reward.value }} {{ reward.type }}
                            </div>
                            <p class="reward-label">{{ i + 1 }}</p>
                        </div>
                    </div>
                </div>
                <div class="user-footer dashboard-item glass" :style="overlayStyles">
                    <div class="user-footer-left">
                        Summer 2023 / Gamebot for Discord
                    </div>
                    <div class="user-footer-right">
                        <a class="share has-text-black" href="#">Share</a>
                    </div>
                </div>
                
                <!-- Rewards claimed modal -->
                <div class="claimed-modal modal" :v-show="claimed.showModal">
                    <h1>Woohoo!</h1>
                    <div class="claimed-reward">
                        <div class="claimed-reward-image">
                            {{ claimed.image }}
                        </div>
                        <div class="claimed-reward-item">
                            {{ claimed.item }}
                        </div>
                    </div>
                    <button class="claimed-modal-close" @click="claimed.showModal = false">
                        Hooray
                    </button>
                </div>
            </div>
        </main>
    </div>
</template>

<style lang="scss">
$dashboard-width: $widescreen;
$user-info-row-height: 2.5rem;

.glass { 
    background-color: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(30px);
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
}

.profile {
    text-align: left;
    background-color: #eee;
    min-height: 700px;
    padding: 150px 20px;
    flex-direction: column;
    align-items: center;

    .dashboard-banner {
        display: block;
        position: relative;
        background: url('/img/dashboard-banner.jpg') no-repeat center center;
        background-color: $gold;
        max-width: $dashboard-width;
        margin: 0 auto 24px auto;
        &:hover {
            box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1), 0 0 0 1px $gold;
        }

    }

    .dashboard-content {
        position: relative;
        max-width: $dashboard-width;
        padding: 0;
        overflow: hidden;
        margin: 0 auto;

        .sidebar {
            max-width: 250px;
        }
        .guild-icon {
            width: 24px;
            height: 24px;
            border-radius: 100%;
            margin-right: 5px;
            overflow: hidden;
        }
        .guild-name {
            line-height: 24px;
            vertical-align: top;
        }
    }

    a.inline-link {
        padding: 0;
        display: inline;
        margin: 0;

        &:hover {
            background-color: transparent;
        }
    }
}

.user-dashboard {
    // background-image: url('https://i.ebayimg.com/images/g/n8IAAOSwltRkNCSF/s-l1200.webp');
    background-size: cover;
    background-color: #eee;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.dashboard-item {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    border-radius: 1rem;
    padding: 1rem;
    margin: 0;
}

.user-experience {
    padding: 0;
    flex-direction: column;
}

.user-dashboard > *, .user-experience > * {
    // margin-top: 1rem;
}

.user-info {
    display: flex;
    width: 50%;
    min-width: 300px;
    align-items: center;
    justify-content: space-between;
    :last-child {
        width: 80%;
    }

    .user-info-text {
        padding: 1rem;
    }

    .user-username {
        font-size: 1.5rem;
        margin: 0;
        align-items: center;
        gap: 0.5rem;
        font-weight: bold;
    }

    .user-info-tags {
        display: flex;
        gap: 0.5rem;
        .tag {
            display: inline-flex;
            justify-content: left;
        }
    }
}

.user-info-row {
    height: $user-info-row-height;
    overflow: hidden;
    margin: 0;
}

.user-statistic {
    text-align: center;
    .statistic-title {
        font-size: 1.8rem;
        line-height: 100%;
        margin: 0;
        font-weight: bold;
    }
    .statistic-subtitle {
        font-size: 0.8rem;
        text-transform: uppercase;
        font-weight: bold;
        line-height: 100%;
        margin: 0;
    }
    .statistic-description {
        font-size: 0.8rem;
        text-transform: uppercase;
        font-weight: bold;
        line-height: 100%;
        padding: 0.35rem 0;
        margin: 0;
    }
}

.game-circles {
    display: block;

    .circle {
        height: $user-info-row-height;
        width: $user-info-row-height;
        
        display: inline-flex;
        margin: 0 0.25rem;
        font-size: 0.8rem;
        font-weight: bold;
        color: white;
    }
}
.circle {
    flex-grow: 1;
    aspect-ratio: 1;
    border-radius: 50%; 
    background-color: gray;

    /* Center Text For Most Played Games */
    display: flex;
    align-items: center;
    justify-content: center;
}

.xp-progress-bar {
    position: relative;
    min-height: 3rem;
    width: 100%;
    border-radius: 0.5rem;
}

.current-progress {
    position: absolute;
    left: 0;
    top: 0;
    height: inherit;
    min-height: inherit;
    border-radius: inherit;
    width: 70%;
    // background-color: rgb(58, 57, 57);
    background: linear-gradient(102.34deg, rgba(206, 84, 226, 0.962972) 49.62%, #33CEFF 109.32%);
}

.xp-progress-label {
    position: absolute;
    width: 100%;
    top: 50%;
    left: 1rem;
    transform: translateY(-50%);
    text-transform: uppercase;
    color: white;
}

.user-status {
    margin: 0;
    padding: 0;
    gap: 1rem;
    align-items: stretch;
}

// Achievements

.user-achievements {
    display: flex;
    flex-grow: 10;
    gap: 1rem;
}

.achievement-list {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    gap: 0.5rem;
}

.achievement-timer {
    text-align: center;
    .achievement-timer-label {
        font-size: 0.8rem;
        margin: 0;
    }

    .achievement-timer-countdown {
        font-size: 1.5rem;
        font-weight: bold;
        margin: 0;
    }
}

.achievement {
    width: 100%;
    .achievement-title {
        font-size: 0.8rem;
        line-height: 1;
        font-weight: bold;
        margin: 0;
    }

    .achievement-info {
        display: flex;
        font-size: 0.8rem;
        margin: 0;
        justify-content: space-between;
    }


    .achievement-progress {
        position: relative;
        width: 100%;
        height: 0.5rem;
        border-radius: 0.5rem;
        background-color: $light;
        .achievement-progress-bar {
            position: absolute;
            left: 0;
            top: 0;
            height: inherit;
            border-radius: inherit;
            width: 33%;
            background-color: $primary;
        }
    }
}

// Balance

.user-balance {
    display: flex;
    align-items: center;
    flex-grow: 1;
    gap: 0.25rem;

    .user-balance-content {
        display: flex;
        justify-content: space-between;
        width: 100%;
    }

    .user-balance-currency {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        font-size: 0.8rem;
        font-weight: bold;
        margin: 0;
    }

    .currency-icon {
        width: 2rem;
        height: 2rem;
    }

    .user-balance-amount {
        display: flex;
        font-size: 0.8rem;
        line-height: 2rem;
    }
}

// Rewards

.rewards-container {
    display: flex;
    position: relative;
    width: 100%;
    gap: 2.5%;

    .reward-container {
        width: 20%;
        text-align: center;
    }

    .reward-label {
        font-size: 1rem;
        text-transform: uppercase;
        font-weight: bold;
        line-height: 100%;
        padding: 0.35rem 0;
        margin: 0.5rem 0;
    }

    .reward {
        width: 100%;
        aspect-ratio: 1;
        border-radius: 0.5rem;
        z-index: 1;
        &.locked {
            background-color: rgba(0, 0, 0, 0.75);
        }
    }

    &.locked::after {
        position: absolute;
        display: grid;
        align-items: center;
        text-align: center;
        color: $warning;
        font-weight: bold;
        content: 'Unlock with Gamebot Premium!';
        width: inherit;
        height: 100%;
        border-radius: 0.5rem;
        background-color: rgba(0, 0, 0, 0.7);
    }
}

.user-footer {
    padding: 0.25rem 1rem;
    border-radius: 1rem;
    font-size: 0.8rem;
    display: flex;
    justify-content: space-between;
}

</style>

<script>
import { XP_LEVELS } from '../assets/js/rewards.js'
import { themeManager } from '../globals/profiles.js'

export default {
    name: 'Profile',
    components: {   
    },
    data() {
        return {
            loading: true,
            user: {
                stats: {}
            },
            page: 'Overview',
            guilds: [],
            rewards: new Array(5).fill({
                "type": 'credits',
                "premium": true,
                "value": 100
            }),
            claimed: {
                showModal: false,
                item: '',
                image: ''
            },
            themeManager: {
                ...themeManager
            },
            theme: 'default'
        }
    },
    computed: {
        userID() {
            let id = this.$route.params.id
            if(!id || id === 'me') {
                id = this.$store.getters.getUser.id
            }
            return id
        },
        displayExperience() {
            let currentLevel = this.user.stats
            let nextLevel = currentLevel + 1

            console.log(currentLevel)

            let currentXP = this.user.stats.xp
            let nextXP = XP_LEVELS[nextLevel]

            return `${currentXP} XP / ${nextXP} XP`
        },
        currentTheme() {
            return this.themeManager.getCurrentTheme();
        },
        overlayStyles() {
            return {
                backgroundColor: this.currentTheme.colors.overlay,
                color: this.currentTheme.colors.text,
                ...(this.currentTheme.colors.glow && {
                    boxShadow: this.currentTheme.colors.glow
                })
            }
        },
        profileStyles() {
            return {
                background: this.currentTheme.colors.background,
                color: this.currentTheme.colors.text,
                ...(this.currentTheme.colors.glow && {
                    boxShadow: this.currentTheme.colors.glow
                })
            };
        },
        bannerStyles() {
            return {
                backgroundColor: this.currentTheme.colors.primary,
                color: this.currentTheme.colors.text
            };
        },
        contentStyles() {
            return {
                backgroundColor: this.currentTheme.colors.secondary,
                color: this.currentTheme.colors.text
            };
        },
        textStyles() {
            return {
                color: this.currentTheme.colors.text
            }
        },
        inverseStyles() {
            return {
                backgroundColor: this.currentTheme.colors.text,
                color: this.currentTheme.colors.primary
            }
        }
    },
    methods: {  
        async fetchItems() {
            let userID = ''
            if(this.$store.getters.getUser.id) {
                userID = `?userId=${this.$store.getters.getUser.id}`
            }

            fetch('/api/shopItems' + userID, {
                method: 'GET',
                headers: {
                    authorization: 'Bearer ' + this.$store.getters.getToken
                }
            })
            .then(res => res.json())
            .then(json => this.data = json)
            .catch(console.error)
        },

        async fetchStats(userID) {
            let userInfo

            if(!userID || userID === 'me') {
                userInfo = this.$store.getters.getStats
            } else {
                await fetch('/api/userStats?userID=' + userID, {
                    method: 'GET',
                    headers: {
                        authorization: 'Bearer ' + this.$store.getters.getToken
                    }
                })
                .then(res => res.json())
                .then(json => userInfo = json)
                .catch(console.error)
            }
            
            return userInfo
        },

        async fetchGuilds() {
            const PERMISSIONS = {
                MANAGE_SERVER: 0x20,
            }

            // Cache the guilds in the store
            if(!this.$store.getters.getGuilds.list
               || this.$store.getters.getGuilds.lastUpdated < Date.now() - 1000 * 60 * 60) {
                fetch('https://discord.com/api/users/@me/guilds', {
                    method: 'GET',
                    headers: {
                        authorization: 'Bearer ' + this.$store.getters.getToken
                    }
                })
                .then(res => res.json())
                .then(json => {
                    this.$store.commit('setGuilds', json)
                    this.guilds = json.filter(guild => guild.permissions & PERMISSIONS.MANAGE_SERVER)
                })
                .catch(console.error)
            } else {
                this.guilds = this.$store.getters.getGuilds.filter(guild => guild.permissions & PERMISSIONS.MANAGE_SERVER)
            }

        },

        async fetchRewards() {
            let userID = ''
            if(this.$store.getters.getUser.id) {
                userID = `?userId=${this.$store.getters.getUser.id}`
            }

            fetch('/api/rewards' + userID, {
                method: 'GET',
                headers: {
                    authorization: 'Bearer ' + this.$store.getters.getToken
                }
            })
            .then(res => res.json())
            .then(json => this.rewards = json)
            .catch(console.error)
        },

        async claimReward(level) {
            let userID = ''
            if(this.$store.getters.getUser.id) {
                userID = `?userId=${this.$store.getters.getUser.id}`
            }

            await fetch('/api/rewards/claim' + userID, {
                method: 'POST',
                headers: {
                    authorization: 'Bearer ' + this.$store.getters.getToken
                },
                body: JSON.stringify({
                    level
                })
            })
            .then(res => res.json())
            .then(this.displayRewards)
            .catch(err => {
                console.error(err)
                this.$buefy.snackbar.open({
                    message: err.message,
                    type: 'is-danger'
                }) 
            })
        },

        async displayRewards() {
            // Open a popup modal showing the reward that was claimed
            this.claimed.showModal = true
        },

        setPage(page) {
            this.page = page
        },
    },
    mounted() {
        let result = this.themeManager.setTheme('default');
        if(!result) {
            console.warn('Unable to load selected theme, loading default.')
        }
    }
}

</script>